import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import * as i1 from '@azavista/components/shared';
import { TimeType, AzavistaSharedModule } from '@azavista/components/shared';
import * as i3 from '@azavista/components/input-field';
import { AzavistaInputFieldModule } from '@azavista/components/input-field';
import * as i4 from '@ngx-translate/core';

class AzavistaDurationService {
    getMaxDuration(seconds) {
        if (seconds <= 0) {
            return { type: TimeType.s, value: 0 };
        }
        const item = this.getSecondsMap().find(x => (seconds % x.seconds) === 0);
        const duration = {
            type: item.timeType,
            value: seconds / item.seconds
        };
        return duration;
    }
    getSecondsMap() {
        if (this.secondsMap) {
            return this.secondsMap;
        }
        this.secondsMap = [
            { timeType: TimeType.w, seconds: 604800 },
            { timeType: TimeType.d, seconds: 86400 },
            { timeType: TimeType.h, seconds: 3600 },
            { timeType: TimeType.m, seconds: 60 },
            { timeType: TimeType.s, seconds: 1 }
        ];
        return this.secondsMap;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: AzavistaDurationService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: AzavistaDurationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: AzavistaDurationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class AzavistaDurationComponent {
    constructor(transSvc, durationSvc) {
        this.transSvc = transSvc;
        this.durationSvc = durationSvc;
        this.seconds = 0;
        this.label = '';
        this.editMode = true;
        this.valueChanged = new EventEmitter();
        this.invalidValueSet = new EventEmitter();
    }
    ngOnInit() {
        this.seconds ||= 0;
        this.secondsMap = this.durationSvc.getSecondsMap();
        this.durationTimes = this.createDurationTimes();
        this.duration = this.durationSvc.getMaxDuration(this.seconds);
        this.fieldsData = this.createFieldsData(this.durationTimes, this.duration);
    }
    onDurationChanged(args) {
        this.duration.type = args.value.id;
        const seconds = this.getSecondsValue(this.duration);
        this.valueChanged.next(seconds);
    }
    onValueChanged(args) {
        const selectedSeconds = args.value;
        this.duration.value = selectedSeconds;
        const seconds = this.getSecondsValue(this.duration);
        this.valueChanged.next(seconds);
    }
    onInvalidValueSet(args) {
        this.invalidValueSet.next();
    }
    getSecondsValue(duration) {
        const secondsMap = this.secondsMap.find(x => x.timeType === duration.type);
        const seconds = duration.value * secondsMap.seconds;
        return seconds;
    }
    createFieldsData(allDurationTimes, duration) {
        const timeTypeFieldValue = {
            displayProperty: 'label',
            items: allDurationTimes,
            selected: allDurationTimes.find(x => x.id === duration.type)
        };
        const fieldsData = {
            value: { editable: true, schema: { type: 'integer', minimum: 0 } },
            timeType: {
                field: { schema: { type: 'object' }, component: "object_enum" /* FieldComponentType.objectEnum */, editable: true },
                value: timeTypeFieldValue
            }
        };
        return fieldsData;
    }
    createDurationTimes() {
        const durationTimes = [
            { id: TimeType.s, label: this.transSvc.getTranslation('SECONDS') },
            { id: TimeType.m, label: this.transSvc.getTranslation('MINUTES') },
            { id: TimeType.h, label: this.transSvc.getTranslation('HOURS') },
            { id: TimeType.d, label: this.transSvc.getTranslation('DAYS') },
            { id: TimeType.w, label: this.transSvc.getTranslation('WEEKS') },
        ];
        return durationTimes;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: AzavistaDurationComponent, deps: [{ token: i1.TranslationService }, { token: AzavistaDurationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.10", type: AzavistaDurationComponent, selector: "azavista-duration", inputs: { seconds: "seconds", label: "label", editMode: "editMode" }, outputs: { valueChanged: "valueChanged", invalidValueSet: "invalidValueSet" }, ngImport: i0, template: "<div class=\"duration-container azavista-duration-component aza-cmp-flex-row aza-cmp-no-gap\">\r\n    <azavista-input-field [field]=\"fieldsData.value\" [value]=\"duration.value\" (valueChanged)=\"onValueChanged($event)\"\r\n        (invalidValueSet)=\"onInvalidValueSet($event)\" [label]=\"label\" [editMode]=\"editMode\" [canEdit]=\"editMode\">\r\n    </azavista-input-field>\r\n    <azavista-input-field [field]=\"fieldsData.timeType.field\" [value]=\"fieldsData.timeType.value\"\r\n        (valueChanged)=\"onDurationChanged($event)\" label=\"{{'DURATION' | translate}}\" [editMode]=\"editMode\"\r\n        [canEdit]=\"editMode\">\r\n    </azavista-input-field>\r\n</div>\r\n", dependencies: [{ kind: "component", type: i3.AzavistaInputFieldComponent, selector: "azavista-input-field", inputs: ["value", "label", "showLabelForBooleans", "showLabelInReadonlyMode", "field", "locale", "dateTimeDisplayFormat", "dateDisplayFormat", "timeDisplayFormat", "canEdit", "tag", "editMode", "fullWidth", "resetValue", "setImageFieldData", "setDocumentFieldData", "setTextFieldValue", "textAreaOptions", "options", "reportErrorOnInit", "fieldAppearance", "floatLabel", "canBeRequiredAndEmpty", "readonlyMode", "autocompleteAttributeValue", "prefixedValueCssName", "setDefaultValueOnEdit", "alwaysDisplayAsOneLiner", "isTouched", "imgFieldSrc", "layoutDensity"], outputs: ["valueChanged", "invalidValueSet", "relationSearchTextChanged", "autocompleteSearchTextChanged", "editModeEntered", "croppedImageUploaded", "documentSelected"] }, { kind: "pipe", type: i4.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: AzavistaDurationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'azavista-duration', template: "<div class=\"duration-container azavista-duration-component aza-cmp-flex-row aza-cmp-no-gap\">\r\n    <azavista-input-field [field]=\"fieldsData.value\" [value]=\"duration.value\" (valueChanged)=\"onValueChanged($event)\"\r\n        (invalidValueSet)=\"onInvalidValueSet($event)\" [label]=\"label\" [editMode]=\"editMode\" [canEdit]=\"editMode\">\r\n    </azavista-input-field>\r\n    <azavista-input-field [field]=\"fieldsData.timeType.field\" [value]=\"fieldsData.timeType.value\"\r\n        (valueChanged)=\"onDurationChanged($event)\" label=\"{{'DURATION' | translate}}\" [editMode]=\"editMode\"\r\n        [canEdit]=\"editMode\">\r\n    </azavista-input-field>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return [{ type: i1.TranslationService }, { type: AzavistaDurationService }]; }, propDecorators: { seconds: [{
                type: Input
            }], label: [{
                type: Input
            }], editMode: [{
                type: Input
            }], valueChanged: [{
                type: Output
            }], invalidValueSet: [{
                type: Output
            }] } });

class AzavistaDurationModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: AzavistaDurationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.10", ngImport: i0, type: AzavistaDurationModule, declarations: [AzavistaDurationComponent], imports: [AzavistaSharedModule, AzavistaInputFieldModule], exports: [AzavistaDurationComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: AzavistaDurationModule, imports: [AzavistaSharedModule, AzavistaInputFieldModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: AzavistaDurationModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AzavistaDurationComponent],
                    imports: [AzavistaSharedModule, AzavistaInputFieldModule],
                    exports: [AzavistaDurationComponent]
                }]
        }] });

class IDuration {
}

/**
 * Generated bundle index. Do not edit.
 */

export { AzavistaDurationComponent, AzavistaDurationModule, AzavistaDurationService, IDuration };
